<template>
  <div class="toolBar">
    <div class="toolTypeList">
      <div class="rightBox">
        <div class="funcButton" v-if="['2d','3d','cmap'].includes(source)">
          <div class="funcButton liveData" @click="onUpload('upload')">
            <img :src="uploadIcon">
          </div>
          <div class="funcButton liveData" @click="onDelete">
            <img :src="deleteIcon">
          </div>
          <div class="funcButton liveData" @click="showAlign">
            <img :src="alignIcon">
          </div>
        </div>
        <div class="toolsList">
          <template v-for="(item,index) in graphicsToolList" >
            <div v-if="!item.hidden && ['poiLabel'].includes(source)"
                 :class="['toolItem',index === toolIndex ? 'active':'']"
                 :key="'graphics' + index"
                 @click="toolClick(item,index)">
              <svg-icon v-if="item.iconSvg" :icon-class="item.iconSvg" />
              <img
                v-else-if="item.iconPath"
                :src="item.iconPath"
                draggable="true"
                @dragstart="dragstart($event, item)"
                effectAllowed="copy"
                dropEffect="copy">
              <span v-else>{{item.title}}</span>
            </div>
          </template>
        </div>
        <div class="funcButton scaleButton" v-if="['poiLabel','route'].includes(source)">
          <div class="funcButton scaleButton">
            <div class="scaleMinus"
                 @click="scale(1)">
              <svg-icon icon-class="minus" />
            </div>
            <el-input v-if="showScaleInput"
                      class="scaleInput"
                      v-model="scaleValue"
                      @keydown.native.enter="changeScaleValue"
                      size="small"></el-input>
            <div v-else
                 @click="showScaleInput = true">{{scaleValue}}%</div>
            <div class="scalePlus"
                 @click="scale(-1)">
              <svg-icon icon-class="plus" />
            </div>
          </div>
          <div class="funcButton moveIndex" v-if="['poiLabel','route'].includes(source)">
            <div @click="moveIndex('top')">
              <svg-icon icon-class="canvas-obj-top" />
            </div>
            <div @click="moveIndex('forward')">
              <svg-icon icon-class="canvas-obj-up"
                        style="font-size:14px;" />
            </div>
            <div @click="moveIndex('backward')">
              <svg-icon icon-class="canvas-obj-down"
                        style="font-size:12px;" />
            </div>
            <div @click="moveIndex('bottom')">
              <svg-icon icon-class="canvas-obj-bottom" />
            </div>
          </div>
        </div>

        <div class="funcButton exportData" v-if="['2d','3d','cmap'].includes(source)">
          <div @click="exportData">保存</div>
        </div>
        <div class="funcButton exportData" v-if="['2d','3d','cmap'].includes(source)">
          <div @click="$emit('initAlign')">重置</div>
        </div>
        <div class="funcButton exportData right" v-if="['cmap'].includes(source)">
          <div @click="$emit('roadEdit')">路网编辑</div>
        </div>
        <div class="funcButton exportData right-1" v-if="['cmap'].includes(source)">
          <div @click="$emit('mapEdit')">地图编辑</div>
        </div>
        <div class="funcButton exportData right-2" v-if="['cmap'].includes(source)">
          <div @click="$emit('mapApply')">地图应用</div>
        </div>
        <div class="funcButton exportData right-3" v-if="['cmap'].includes(source)">
          <div @click="$emit('downLoadSvg')">下载svg</div>
        </div>
        <div class="funcButton" v-if="['live', 'navigation'].includes(source)">
          <div :class="['funcButton','liveData',$parent.isHiddenMode?'active':'']" @click="$emit('hiddenModel')">
            <img :src="hiddenIcon">
          </div>
          <div class="funcButton liveData" @click="onDownloadPanorama">
            <img :src="downloadIcon">
          </div>
          <div class="funcButton liveData" @click="onUpload('replace')">
            <img :src="replaceIcon">
          </div>
        </div>
        <RouteBar v-if="source=='route'"/>
      </div>
      <el-dialog title="数据"
                 :visible.sync="jsonViewerVisible">
        <json-viewer boxed
                     copyable
                     :value="labelData"></json-viewer>
      </el-dialog>
      <input ref="uploader"
             style="position:fixed;"
             type="file"
             :show-file-list="false"
             class="upload__input"
             :accept="accept"
             id="uploader"
             @change="previewImage">

    </div>

    <el-dialog title="数据"
               :visible.sync="jsonViewerVisible">
      <json-viewer boxed
                   copyable
                   :value="labelData"></json-viewer>
    </el-dialog>
    <input ref="uploader"
           type="file"
           :show-file-list="false"
           class="upload__input"
           :accept="accept"
           @change="previewImage">

  </div>
</template>

<script>
/* eslint-disable global-require */
import JsonViewer from 'vue-json-viewer';
import { dataExporter, toolsConfig, LayerManager, EventManager, eventHub } from '@aibee/vincent';
import { createIcon, deleleIcon, queryAllIcon } from '@/api/map';
import RouteBar from './routeBar.vue';

export default {
  name: 'toolBar',
  components: { JsonViewer, RouteBar },
  props: {
    accept: { type: String, default: 'image/*' },
  },
  data() {
    return {
      toolTypes: [
        { name: '插入' },
        { name: '图形' },
      ],
      toolIndex: 0,
      graphicsToolList: [],
      scaleValue: 100,
      jsonViewerVisible: false,
      labelData: null,
      showScaleInput: false,
      uploadIcon: require('@/assets/image/upload.png'),
      deleteIcon: require('@/assets/image/delete.png'),
      alignIcon: require('@/assets/image/align_icon.png'),
      hiddenIcon: require('@/assets/image/hidden.png'),
      downloadIcon: require('@/assets/image/download.png'),
      replaceIcon: require('@/assets/image/replace.png'),
      uploadSource: '',
      toolConfig: [
        {
          type: 'DirectSelect',
          hidden: true,
        },
        {
          title: '点',
          type: 'CirclePoint',
          loader: () => require('@/components/mapComponents/shapes/CirclePoint.js'),
          iconSvg: 'point',
          shapeParams: {
            left: 0,
            top: 0,
            strokeWidth: 2,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            radius: 10,
            fill: 'blue',
          },
        },
      ],
    };
  },
  computed: {
    source() {
      return this.$route.params.source;
    },
  },
  created() {
  },
  beforeDestroy() {
    eventHub.$off('shapeTypeChange');
    EventManager.eventStatus.setShapeType('DirectSelect');
  },
  mounted() {
    this.setToolsConfig();
    this.initToolBar();
    eventHub.$on('shapeTypeChange', this.toolTypeChange);
  },
  methods: {
    setToolsConfig() {
      // // 引入全部工具
      // const config = [
      //   'DirectSelect',
      //   'CirclePoint',
      //   'CommonLine',
      //   'LinePoint',
      //   'SkeletonPolygon',
      // ];
      toolsConfig.setConfigTools(this.toolConfig);
    },
    initToolBar() {
      this.graphicsToolList = toolsConfig.getTools().filter(t => this.toolConfig.some(c => c.type === t.type));
      const firstTool = this.graphicsToolList[0];
      if (!firstTool) return;
      this.changeTool(firstTool, 0);
      EventManager.eventStatus.setShapeType(firstTool.type);
    },
    showAlign() {
      this.$emit('hideMesh');
    },
    toolClick(tool, index) {
      if (tool.ignoreActive) return;
      if (this.toolIndex === index) {
        const firstTool = this.graphicsToolList[0];
        if (!firstTool) return;
        this.changeTool(firstTool, 0);
      } else {
        this.changeTool(tool, index);
      }
    },
    changeTool(tool, index) {
      const { canvasConfig } = tool;
      if (canvasConfig) {
        const currentLayer = LayerManager.getCurrentLayer();
        if (!currentLayer) {
          return false;
        }
        Object.keys(canvasConfig).forEach((item) => {
          currentLayer.canvas[item] = canvasConfig[item];
        });
      }
      this.toolIndex = index;
      EventManager.eventStatus.setShapeType(tool.type);
      return tool;
    },
    toolTypeChange(type) {
      this.graphicsToolList.forEach((tool, index) => {
        if (tool.type === type) {
          this.toolClick(tool, index);
        }
      });
    },
    dragstart(e, item) {
      if (e.currentTarget === e.target && item.type) {
        e.dataTransfer.setData('mod-config', JSON.stringify(item));
      }
    },
    drawStart(item) {
    },
    changeScaleValue(e) {
      const layers = LayerManager.getAllLayers();
      if (Number.isNaN(parseFloat(e.target.value))) return;
      this.scaleValue = parseFloat(e.target.value);
      layers.forEach((item) => {
        item.scale(this.scaleValue / 100);
      });
      this.showScaleInput = false;
    },
    scale(val) {
      const layers = LayerManager.getAllLayers();
      this.scaleValue -= val;
      layers.forEach((item) => {
        item.scale(this.scaleValue / 100);
      });
    },
    groupActive() {
      const currentLayer = LayerManager.getCurrentLayer();
      if (!currentLayer) {
        return false;
      }
      return currentLayer.ActiveToGroup();
    },
    unGroupActive() {
      const currentLayer = LayerManager.getCurrentLayer();
      if (!currentLayer) {
        return false;
      }
      return currentLayer.unGroup();
    },
    exportData() {
      this.$emit('exportData');
    },
    exportCmapData() {
      const objects = LayerManager.getCurrentLayer().getAllObjects();
      const svgIcons = objects.filter(item => item.groupType === 'svgIcon');
      const params = {

      };
    },
    importData() {

    },
    moveIndex(type) {
      const currentLayer = LayerManager.getCurrentLayer();
      if (!currentLayer) {
        return false;
      }
      const { canvas } = currentLayer;
      const activeObjects = canvas.getActiveObject();
      if (!activeObjects) return false;
      switch (type) {
        case 'forward':
          activeObjects.bringForward(true);
          break;
        case 'backward':
          activeObjects.sendBackwards(true);
          break;
        case 'top':
          activeObjects.bringToFront();
          break;
        case 'bottom':
          activeObjects.sendToBack();
          break;

        default:
          break;
      }
      return activeObjects;
    },
    previewImage(e) {
      //  加载2D图
      const fileReader = new FileReader();
      let fileType;
      fileReader.addEventListener(
        'load',
        () => {
          const thethis = this;
          const image = new Image();
          image.src = fileReader.result;
          // eslint-disable-next-line func-names
          image.onload = function () {
            if (thethis.uploadSource === 'upload') thethis.$emit('succeeUpload', { map_file: fileReader.result.replace(/data:image.*?,/gi, ''), img_type: fileType });
            if (thethis.uploadSource === 'replace')thethis.$emit('handleReplaceImg', fileReader.result.replace(/data:image.*?,/gi, ''));
            e.target.value = null;
          };
        },
        false,
      );
      const file = this.$refs.uploader.files[0];
      if (file) {
        fileType = file.name.substr(file.name.lastIndexOf('.') + 1, file.name.length);
        fileReader.readAsDataURL(file);
      }
    },
    onUpload(val) {
      this.uploadSource = val;
      this.$refs.uploader.click();
    },
    onDelete() {
      this.$emit('handleDeleteImg');
    },
    onDownloadPanorama() {
      this.$emit('handleDownloadPanorama');
    },
  },
};
</script>
<style lang="scss" scoped>
.toolBar {
  // height: 50px;
  .toolTypeList {
    width: 100%;
    color: #d8d8d8;
    font-size: 12px;
    display: flex;
    justify-content: flex-start;
    background-color: #1b1b1b;
    .rightBox {
      // margin-left: 20px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      &-icon {
        height: 22px;
        margin-right: 10px;
        cursor: pointer;
      }
      .funcButton {
        height: 22px;
        font-size: 12px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
        & + .funcButton {
          margin-left: 10px;
        }
        &.disabled {
          background-color: #716d6d;
          pointer-events: none;
        }
      }

      .scaleButton {
        background-color: #535353;
        padding: 0 10px;
        box-sizing: border-box;
        svg {
          display: block;
        }
        .scaleMinus {
          border-radius: 50%;
          font-size: 14px;
          margin-right: 5px;
          fill: #fff;
          box-shadow: #f1f1f1 0px 0px 4px;
          transition: box-shadow 0.1s;
          &:active {
            box-shadow: none;
          }
        }
        ::v-deep .scaleInput .el-input__inner {
          width: 30px;
          padding: 0;
          text-align: center;
          font-size: 12px;
        }
        .scalePlus {
          border-radius: 50%;
          font-size: 14px;
          margin-left: 5px;
          box-shadow: #f1f1f1 0px 0px 4px;
          transition: box-shadow 0.1s;
          &:active {
            box-shadow: none;
          }
        }
      }
      .setGroup {
        > div {
          background-color: #535353;
          width: 70px;
          padding: 5px 10px;
          text-align: center;
          &:nth-child(1) {
            width: 60px;
            margin-right: 1px;
          }
        }
      }
      .exportData {
        background-color: #535353;
        padding: 5px 10px;
      }
      .liveData {
        background-color: #535353;
        width: 40px;
        display: flex;
        justify-content: center;
        &:hover{
          background-color: #797979;
        }
      }
      .active{
        background-color: #3785f7;
      }
      .exportData {
        background-color: #535353;
        padding: 5px 10px;
      }
      .moveIndex {
        > div {
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #535353;
          width: 20px;
          height: 100%;
          margin-right: 1px;
        }
      }
    }
  }
  .toolsList {
    border-top: 1px solid #333;
    height: 22px;
    display: flex;
    background-color: #1b1b1b;
    align-items: center;
    padding: 0 10px;
    .toolItem {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 40px;
      padding: 0 5px;
      border-radius: 4px;
      // margin: 0 10px;
      &.active {
        background-color: #535353;
      }
      .svg-icon{
        font-size: 14px;
      }
    }
    img {
      width: 15px;
      display: block;
    }
    span {
      display: block;
      color: white;
      cursor: pointer;
    }
  }
  .upload__input {
    visibility: hidden;
    position:fixed;
    height:0;
  }
  .right {
    position: absolute;
    right: 280px;
  }
  .right-1 {
    position: absolute;
    right: 360px;
  }
  .right-2 {
    position: absolute;
    right: 440px;
  }
  .right-3 {
    position: absolute;
    right: 520px;
  }
}
</style>
